import { BadgeId, BadgesStats } from '../Models';
import { WritingBadge } from './WritingBadge';

export default class CupcakeBadge extends WritingBadge {
  public readonly id = BadgeId.cupcake;

  public evaluateIfAchieved = (stats: BadgesStats) => {
    return stats.pagesCount >= 30;
  };
}



// WEBPACK FOOTER //
// ./src/containers/Badges/AllBadges/cupcake.ts